import { render, staticRenderFns } from "./ProjectNotices.vue?vue&type=template&id=46e81aa8&"
import script from "./ProjectNotices.vue?vue&type=script&lang=js&"
export * from "./ProjectNotices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports